module.exports = __webpack_public_path__ + "static/media/resume.3206409d.pdf";